export default __webpack_public_path__ + "static/media/brand_logo.0927c441.png";